// CB:BEGIN fix-feature-flags-tdz
// Pure functions with no dependencies - safe from TDZ
// CB:END fix-feature-flags-tdz

export const isDemoMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (!window.localStorage) return false;
  return (
    window.localStorage.getItem('cb_demo_mode') === '1' ||
    window.localStorage.getItem('cb_test_mode') === '1'
  );
};

export const isTestMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (!window.localStorage) return false;
  return window.localStorage.getItem('cb_test_mode') === '1';
};

// Helper function to determine if dev features should be available
// Dev features should be available in dev mode, but NOT disabled in demo mode
export const shouldShowDevFeatures = (): boolean => {
  // Always show dev features in development mode
  if (import.meta.env.DEV) return true;
  
  // In production, only show if explicitly in test mode
  return isTestMode();
};

export const setTestMode = (enabled: boolean): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem('cb_test_mode', enabled ? '1' : '0');
};

export const setDemoMode = (enabled: boolean): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem('cb_demo_mode', enabled ? '1' : '0');
};

export const enableDemoMode = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.setItem('cb_demo_mode', '1');
  // Keep compatibility with any pre-existing "test mode" checks:
  window.localStorage.setItem('cb_test_mode', '1');
  if (typeof document !== 'undefined') {
    document.body.classList.add('cb-demo');
  }
};

export const disableDemoMode = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.removeItem('cb_demo_mode');
  window.localStorage.removeItem('cb_test_mode');
  if (typeof document !== 'undefined') {
    document.body.classList.remove('cb-demo');
  }
};

export const initDemoModeBodyClass = (): void => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (isDemoMode()) {
    document.body.classList.add('cb-demo');
  } else {
    document.body.classList.remove('cb-demo');
  }
};

export const getTestModeHeader = (): Record<string, string> => {
  return {
    'x-cb-test-mode': isTestMode() ? '1' : '0'
  };
};
